<mat-form-field [appearance]="appearance" floatLabel="always" [class.margin-bottom-1]="hint != null">
  <mat-label>{{label}}</mat-label>

  <input matInput [matDatepicker]="picker" [placeholder]="placeholder" [formControl]="formControl"  [errorStateMatcher]="matcher" [readonly]="readonly">
  <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="readonly || disabled"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
  <mat-hint>{{hint}}</mat-hint>
  <mat-error [innerHTML]="errors"></mat-error>
</mat-form-field>
